import React from 'react';

import { ControlCategorySpec } from 'src/models/Sidekick/SidekickModuleSpec';
import ControlGroup from './ControlGroup';
import { Section } from 'src/presentation/components/forms/Layout';

export default function ControlCategory({
  specAttr,
  controlCategorySpec,
}: {
  specAttr: string;
  controlCategorySpec: ControlCategorySpec;
}) {
  return (
    <Section>
      {controlCategorySpec.controlGroups.map((controlGroup, idx) => (
        <ControlGroup specAttr={`${specAttr}.controlGroups.${idx}`} key={idx} controlGroup={controlGroup} />
      ))}
    </Section>
  );
}
